import React from 'react';

import { Divider } from '@cube3/ui/src/Surface/Divider';

import { NavGroup } from '@cube3/cubicle/src/core/atoms/Navigation/NavGroup';
import { VBox } from '@cube3/cubicle/src/core/templates/layout/Flex';

import { DroppableNavGroup } from './prefabs/DroppableNavGroup';
import { NavDrawerItem } from './NavigationDrawer';
import { useNavigationItem } from './hooks/useNavigationItem';
import { Scrollbar } from '@cube3/cubicle/src/core/atoms/Scrollbar';
import { isMobile } from 'react-device-detect';
import { ModalNames } from '../Modals/modalIndex';

/// @Author : Simon @ AmbassadorsLAB
/// @Summary
/// Layout component on the left side of the screen that can be used for searching
/// Cube and navigation to pages within cube.
///

export interface LinkerProps extends NavDrawerItem {
  admin?: boolean;
  onClick?: (
    ev?: React.MouseEvent,
    openModal?: (modal: ModalNames, data?: any) => void
  ) => void;
}

interface LinkerGroup {
  groupName: string;
  items: LinkerProps[];
  alignBottom?: boolean;
  title?: string;
}

interface NavDrawerProperties {
  isAdmin: boolean;
  navigationItems: LinkerGroup[];
  backUrl?: string;
}

const NavigationDrawerInner: React.FC<NavDrawerProperties> = React.memo(
  (props) => {
    const { navigationItems, isAdmin, backUrl } = props;

    const { handleItemClick, isActive } = useNavigationItem(backUrl);

    const hasBottomItems = navigationItems.some((g) => g.alignBottom);

    return (
      <VBox
        style={{
          width: '100%',
          height: '100%'
        }}
      >
        <div
          style={{
            marginRight: 10,
            height: isMobile ? 'calc(100vh - 350px)' : '100%',
            minHeight: isMobile ? 350 : 200
          }}
        >
          <Scrollbar
            autoHeight={isMobile}
            autoHeightMax={
              isMobile ? 'calc(100vh - 350px)' : undefined
            }
            autoHeightMin={isMobile ? 350 : undefined}
            colorScrollbar="main"
          >
            {navigationItems
              .filter((g) => !g.alignBottom)
              .map((g) =>
                g.groupName === 'main' ? (
                  <DroppableNavGroup
                    key={g.title || g.groupName}
                    group={g}
                    isAdmin={isAdmin}
                    onItemClick={handleItemClick}
                    isActive={isActive}
                  />
                ) : (
                  <NavGroup
                    key={g.title || g.groupName}
                    group={g}
                    isAdmin={isAdmin}
                    onItemClick={handleItemClick}
                    isActive={isActive}
                  />
                )
              )}
          </Scrollbar>
        </div>

        {
          hasBottomItems && (
            <div>
              <Divider gutter />
              {navigationItems
                .filter((g) => g.alignBottom)
                .map((g) => (
                  <NavGroup
                    key={g.title || g.groupName}
                    group={g}
                    isAdmin={isAdmin}
                    onItemClick={handleItemClick}
                    isActive={isActive}
                  />
                ))}
            </div>
          )
        }
      </VBox >
    );
  }
);

export default NavigationDrawerInner;
